import { create } from "zustand";
import { ProfileData } from "@/interface/types";
import { setCookie, deleteCookie } from "cookies-next";
import { COOKIE_CONFIG } from "@/config";

interface ProfileState {
  profileData: Partial<ProfileData>;
  setProfile: (userData: ProfileData) => void;
  setAccessToken: (token: string) => void;
  clearProfile: () => void;
}

const useProfileStore = create<ProfileState>((set) => ({
  profileData: {},

  setProfile: (profileData) => {
    // ✅ Sync Authorization cookie
    if (profileData?.accessToken) {
      setCookie(COOKIE_CONFIG.authorization, profileData.accessToken, {
        path: "/",
        secure: process.env.NODE_ENV === "production",
        sameSite: "none",
      });
    }

    set(() => ({ profileData }));
  },

  setAccessToken: (token) => {
    // ✅ Sync Authorization cookie
    setCookie(COOKIE_CONFIG.authorization, token, {
      path: "/",
      secure: process.env.NODE_ENV === "production",
      sameSite: "none",
    });

    set((state) => ({
      profileData: {
        ...state.profileData,
        accessToken: token,
      },
    }));
  },

  clearProfile: () => {
    // ✅ Remove Authorization cookie on logout
    deleteCookie(COOKIE_CONFIG.authorization, { path: "/" });

    set(() => ({ profileData: {} }));
  },
}));

export default useProfileStore;
